



































































































































































































































// componnents
import { PageHeader, AccordionFilters } from '@/components'
import { Select2, Select, DatePicker } from '@/components/general'

import {
  optionsWorkType,
  optionsWorkCategory,
  APP_URL_API
} from '@/constants'
// vue
import { computed, defineComponent, ref, Ref } from '@vue/composition-api'

// hooks
import { useHeadquarter, useEmployeesOp, useArea } from '@/hooks'

// types
import { ReportBoletas, FilterReportBoletas } from '@/models/reports/ReportBoletas'

import { ReportBoletaService } from '@/services/reports'

// libs
import { dateLibs, alerts, getFullNameFormat } from '@/utils'
import moment from 'moment'

export default defineComponent({
  name: 'Boletas',
  components: {
    PageHeader,
    Select2,
    Select,
    DatePicker,
    AccordionFilters
  },
  setup () {
    const ATTENDED = 'A'
    const ABSENT = 'X'
    const SUNDAY = 'D'
    const HOLIDAY = 'F'
    const MA = 'MA'
    const NUMBER = 'number'
    const title = 'Boletas de pago con firma electronica'
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Boletas de pago',
        active: true
      }
    ]

    const activeStatusOptions = [
      { value: 'active', text: 'Activos' },
      { value: 'inactive', text: 'Inactivos' }
    ]
    const activeStatus: Ref<string|null> = ref(null)
    const reportData: Ref<ReportBoletas|null> = ref(null)
    const loading = ref(false)
    const filters: Ref<FilterReportBoletas> = ref({
      year: 0,
      month: 0,
      work_type: null,
      work_category: null,
      employees: []
    })
    const { loadingHeadquartes, getHeadquatersActivated, headquartersSelectOptions } = useHeadquarter()
    getHeadquatersActivated()

    const { areasOptions, getAreasActive, loadingAreas, areas } = useArea()
    getAreasActive()

    const subareaOptions = computed(() => {
      const areaSelected = areas.value.find(a => Number(a.id) === Number(filters.value.area))
      if (areaSelected) {
        return areaSelected.subAreas?.map(sub => {
          return {
            value: sub.id,
            text: sub.name
          }
        })
      }
      return []
    })

    const { employees } = useEmployeesOp()

    const allEmployees = computed(() => {
      return employees.value.map(employee => {
        return {
          value: employee.id,
          text: getFullNameFormat(employee)
        }
      })
    })

    const getAssistenceValue = (assistances, date) => {
      let html = ''
      const assistance = assistances.find(a => a.date === date)
      if (assistance) {
        const v = assistance.value
        const p = assistance.permiso
        switch (v) {
          case ABSENT:
            html = '<strong class="text-danger">X<br></strong>' + p
            break
          case ATTENDED:
            html = '<strong class="text-success"><i class="fas fa-check" /></i><span style="color: white">A</span><br></strong>' + p
            break
          case HOLIDAY:
            html = '<strong class="text-info">F<br></strong>' + p
            break
          case SUNDAY:
            html = '<strong class="text-warning">D<br></strong>' + p
            break
          case NUMBER:
            html = '<strong class="text-dark">' + p + '<br></strong>'
            break
          case MA:
            html = '<strong class="text-dark">MA<br></strong>'
            break
          default:
            html = ''
            break
        }
      }
      return html
    }

    const stripHtmlTags = (html) => {
      const tmp = document.createElement('div')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    }

    const generate = async () => {
    //  const { date_init, date_end, headquarter } = filters.value
    //  if (!date_init || !date_end || !headquarter) {
    //   alerts.error('Los campos de fecha y sede son obligatorios para generar el reporte.')
    //    return
    //  }
      loading.value = true
      reportData.value = await ReportBoletaService.getReportBoletas(filters.value)
      loading.value = false
    }

    const currentDate = moment()
    const year: Ref<number> = ref(currentDate.year())
    const month: Ref<number> = ref(currentDate.month() - 1)

    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const work_type: Ref<number> = ref(0)
    const work_category: Ref<number> = ref(0)
    const employee: Ref<number> = ref(0)

    const { employeesOp, getEmployees, loadingEmployees } = useEmployeesOp()
    getEmployees()

    const showConfirmationModal = ref(false)

    const openConfirmationModal = () => {
      showConfirmationModal.value = true
    }

    const closeConfirmationModal = () => {
      showConfirmationModal.value = false
    }
    const showConfirmationModal2 = ref(false)

    const openConfirmationModal2 = () => {
      showConfirmationModal2.value = true
    }

    const closeConfirmationModal2 = () => {
      showConfirmationModal2.value = false
    }

    const urlReport = computed(() => {
      return `${APP_URL_API}reports/boletas?year=${filters.value.year}&month=${filters.value.month}&workType=${filters.value.work_type}&workCategory=${filters.value.work_category}&employees=${filters.value.employees.join(',')}&tipo=1`
    })
    const urlReport2 = computed(() => {
      return `${APP_URL_API}reports/boletas?year=${filters.value.year}&month=${filters.value.month}&workType=${filters.value.work_type}&workCategory=${filters.value.work_category}&employees=${filters.value.employees.join(',')}&tipo=2`
    })
    const generateUrlForItem = (item) => {
      return `${APP_URL_API}reports/payment-slips?year=${item.year}&month=${item.mes}&fortnight=3&workType=&workCategory=&employees=${item.employee.id}`
    }
    const generateUrlForItem2 = (item) => {
      return `${APP_URL_API}reports/boletas?year=${item.year}&month=${item.mes}&workType=&workCategory=&employees=${item.employee.id}&tipo=2`
    }
    const delayedGenerate = () => {
      setTimeout(() => {
        generate() // Llama al método generate directamente, ya que delayedGenerate está dentro de setup
      }, 4000)
    }
    const executeAction = () => {
      // Aquí decides si llamar a generate o delayedGenerate
      // Por ejemplo:
      // generate();
      // o
      delayedGenerate()
      closeConfirmationModal()
      closeConfirmationModal2()
    }
    return {
      title,
      breadcrumbs,
      year,
      month,
      generateUrlForItem,
      generateUrlForItem2,
      years,
      months,
      optionsWorkType,
      optionsWorkCategory,
      work_type,
      work_category,
      employeesOp,
      loadingEmployees,
      employee,
      urlReport,
      urlReport2,
      loadingHeadquartes,
      headquartersSelectOptions,
      filters,
      allEmployees,
      generate,
      loading,
      moment,
      areasOptions,
      loadingAreas,
      subareaOptions,
      reportData,
      getFullNameFormat,
      ATTENDED,
      ABSENT,
      HOLIDAY,
      SUNDAY,
      getAssistenceValue,
      activeStatus,
      activeStatusOptions,
      showConfirmationModal,
      openConfirmationModal,
      closeConfirmationModal,
      executeAction,
      delayedGenerate,
      showConfirmationModal2,
      openConfirmationModal2,
      closeConfirmationModal2
    }
  }
})
